var _path, _rect, _g, _path2, _path3, _g2, _path4, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsightsPageArtWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_39131",
    "data-name": "Group 39131",
    xmlns: "http://www.w3.org/2000/svg",
    width: 551.384,
    height: 400,
    viewBox: "0 0 551.384 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_119701",
    "data-name": "Path 119701",
    d: "M548.068,400.077c17.07-70.744-38.192-75.816-25.637-138.823,8.242-41.359-8.148-133.049-107.941-108.438-87.162,21.5-112.633-41.578-155.026-68.544C212.118,54.155,104.024,65.98,106.816,155.757S61.745,212.3,14.927,286.959c-26.449,42.178-12.737,87.032,2.714,113.119Z",
    transform: "translate(0 -0.077)",
    fill: "#0e475c"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25237",
    "data-name": "Rectangle 25237",
    width: 551.384,
    height: 399.553,
    fill: "#0e556f",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39128",
    "data-name": "Group 39128",
    transform: "translate(59.281 117.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39112",
    "data-name": "Group 39112",
    transform: "translate(320.983 20.755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25238",
    "data-name": "Rectangle 25238",
    width: 108.287,
    height: 181.938,
    transform: "translate(111.681 181.938) rotate(180)",
    fill: "#66c8ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25239",
    "data-name": "Rectangle 25239",
    width: 108.287,
    height: 181.938,
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25240",
    "data-name": "Rectangle 25240",
    width: 93.795,
    height: 63.372,
    transform: "translate(7.375 10.164)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25241",
    "data-name": "Rectangle 25241",
    width: 50.339,
    height: 33.836,
    transform: "translate(49.213 133.005)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119702",
    "data-name": "Path 119702",
    d: "M391.943,180.485s16.015-2,25.8,7.02,28.016.8,35.355,0c12.763-1.389,22.768,2.786,25.734,7.376v13.769H391.943Z",
    transform: "translate(-380.701 -137.976)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25242",
    "data-name": "Rectangle 25242",
    width: 0.671,
    height: 21.5,
    transform: "translate(23.655 20.35)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25243",
    "data-name": "Rectangle 25243",
    width: 0.671,
    height: 21.5,
    transform: "translate(49.99 29.576)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25244",
    "data-name": "Rectangle 25244",
    width: 0.671,
    height: 21.5,
    transform: "translate(77.165 24.711)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119703",
    "data-name": "Path 119703",
    d: "M412.537,161.6h-5.144a.561.561,0,0,1-.559-.559h0a.561.561,0,0,1,.559-.558h5.144a.561.561,0,0,1,.559.558h0A.561.561,0,0,1,412.537,161.6Z",
    transform: "translate(-380.718 -137.954)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119704",
    "data-name": "Path 119704",
    d: "M412.537,163.618h-5.144a.561.561,0,0,1-.559-.558h0a.561.561,0,0,1,.559-.559h5.144a.561.561,0,0,1,.559.559h0A.561.561,0,0,1,412.537,163.618Z",
    transform: "translate(-380.718 -137.957)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119705",
    "data-name": "Path 119705",
    d: "M438.51,172.575h-5.144a.561.561,0,0,1-.559-.559h0a.561.561,0,0,1,.559-.559h5.144a.561.561,0,0,1,.559.559h0A.561.561,0,0,1,438.51,172.575Z",
    transform: "translate(-380.747 -137.967)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119706",
    "data-name": "Path 119706",
    d: "M438.51,174.548h-5.144a.56.56,0,0,1-.559-.558h0a.561.561,0,0,1,.559-.559h5.144a.561.561,0,0,1,.559.559h0A.56.56,0,0,1,438.51,174.548Z",
    transform: "translate(-380.747 -137.969)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119707",
    "data-name": "Path 119707",
    d: "M466.162,164.458h-5.143a.561.561,0,0,1-.559-.559h0a.561.561,0,0,1,.559-.559h5.143a.561.561,0,0,1,.559.559h0A.561.561,0,0,1,466.162,164.458Z",
    transform: "translate(-380.778 -137.957)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119708",
    "data-name": "Path 119708",
    d: "M466.162,166.432h-5.143a.561.561,0,0,1-.559-.559h0a.561.561,0,0,1,.559-.559h5.143a.561.561,0,0,1,.559.559h0A.561.561,0,0,1,466.162,166.432Z",
    transform: "translate(-380.778 -137.96)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39106",
    "data-name": "Group 39106",
    transform: "translate(81.283 79.121)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10898",
    "data-name": "Ellipse 10898",
    cx: 9.261,
    cy: 9.261,
    r: 9.261,
    transform: "translate(0 18.283) rotate(-80.783)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119709",
    "data-name": "Path 119709",
    d: "M481.169,227.766a8.475,8.475,0,0,1-14.205,6.246l5.73-6.246V219.29A8.476,8.476,0,0,1,481.169,227.766Z",
    transform: "translate(-462.068 -217.141)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119710",
    "data-name": "Path 119710",
    d: "M469.464,226.279h-3.044a.256.256,0,0,1-.256-.255h0a.256.256,0,0,1,.256-.255h3.044a.256.256,0,0,1,.255.255h0A.256.256,0,0,1,469.464,226.279Z",
    transform: "translate(-462.067 -217.148)",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39107",
    "data-name": "Group 39107",
    transform: "translate(59.653 80.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119711",
    "data-name": "Path 119711",
    d: "M440.409,227.765a9.261,9.261,0,1,1,9.262,9.262A9.261,9.261,0,0,1,440.409,227.765Z",
    transform: "translate(-440.409 -218.504)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119712",
    "data-name": "Path 119712",
    d: "M449.672,227.766l5.208,6.688a8.476,8.476,0,1,1,3.232-7.462Z",
    transform: "translate(-440.41 -218.505)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119713",
    "data-name": "Path 119713",
    d: "M456.212,229.872h-2.119a.256.256,0,0,1-.255-.255h0a.256.256,0,0,1,.255-.255h2.119a.256.256,0,0,1,.255.255h0A.256.256,0,0,1,456.212,229.872Z",
    transform: "translate(-440.424 -218.516)",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39108",
    "data-name": "Group 39108",
    transform: "translate(82.647 105.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119714",
    "data-name": "Path 119714",
    d: "M463.428,253.3a9.261,9.261,0,1,1,9.262,9.262A9.261,9.261,0,0,1,463.428,253.3Z",
    transform: "translate(-463.428 -244.04)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119715",
    "data-name": "Path 119715",
    d: "M481.169,253.3a8.475,8.475,0,0,1-14.205,6.246l5.73-6.246v-8.476A8.476,8.476,0,0,1,481.169,253.3Z",
    transform: "translate(-463.432 -244.041)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119716",
    "data-name": "Path 119716",
    d: "M469.464,251.815h-3.044a.256.256,0,0,1-.256-.255h0a.256.256,0,0,1,.256-.255h3.044a.256.256,0,0,1,.255.255h0A.256.256,0,0,1,469.464,251.815Z",
    transform: "translate(-463.431 -244.048)",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39109",
    "data-name": "Group 39109",
    transform: "translate(59.653 105.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119717",
    "data-name": "Path 119717",
    d: "M440.409,253.3a9.261,9.261,0,1,1,9.262,9.262A9.261,9.261,0,0,1,440.409,253.3Z",
    transform: "translate(-440.409 -244.04)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119718",
    "data-name": "Path 119718",
    d: "M458.112,252.527a8.476,8.476,0,1,0-3.232,7.462l-5.208-6.688Z",
    transform: "translate(-440.41 -244.041)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119719",
    "data-name": "Path 119719",
    d: "M456.212,255.408h-2.119a.256.256,0,0,1-.255-.255h0a.256.256,0,0,1,.255-.255h2.119a.256.256,0,0,1,.255.255h0A.256.256,0,0,1,456.212,255.408Z",
    transform: "translate(-440.424 -244.052)",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39110",
    "data-name": "Group 39110",
    transform: "translate(51.176 137.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119720",
    "data-name": "Path 119720",
    d: "M478.128,302.559H431.923v-27.3h.575v26.727h45.631Z",
    transform: "translate(-431.923 -275.257)",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39111",
    "data-name": "Group 39111",
    transform: "translate(53.949 138.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119721",
    "data-name": "Path 119721",
    d: "M446.37,292.691c-5.656-4.5-11.671,0-11.671,0v7.7h42.286v-19.9C465.493,280.783,452.026,297.194,446.37,292.691Z",
    transform: "translate(-434.699 -276.377)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119722",
    "data-name": "Path 119722",
    d: "M435.182,277.341h19.7a.484.484,0,0,0,0-.969h-19.7a.484.484,0,0,0,0,.969Z",
    transform: "translate(-434.699 -276.372)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119723",
    "data-name": "Path 119723",
    d: "M435.182,279.709h19.7a.484.484,0,1,0,0-.969h-19.7a.484.484,0,0,0,0,.969Z",
    transform: "translate(-434.699 -276.375)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25245",
    "data-name": "Rectangle 25245",
    width: 13.839,
    height: 0.968,
    rx: 0.396,
    transform: "translate(0 4.599)",
    fill: "#d0d0d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39117",
    "data-name": "Group 39117",
    transform: "translate(142.326)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25246",
    "data-name": "Rectangle 25246",
    width: 148.164,
    height: 223.448,
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25247",
    "data-name": "Rectangle 25247",
    width: 119.289,
    height: 132.962,
    transform: "translate(14.316 12.499)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119724",
    "data-name": "Path 119724",
    d: "M218.7,305.279a21.454,21.454,0,1,1,21.454,21.453A21.454,21.454,0,0,1,218.7,305.279Z",
    transform: "translate(-201.852 -117.337)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119725",
    "data-name": "Path 119725",
    d: "M258.294,305.283a18.133,18.133,0,1,0-7.135,14.419l-11-14.419,16.947,6.468A18.114,18.114,0,0,0,258.294,305.283Z",
    transform: "translate(-201.855 -117.341)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119726",
    "data-name": "Path 119726",
    d: "M291.88,305.279a21.454,21.454,0,1,1,21.454,21.453A21.454,21.454,0,0,1,291.88,305.279Z",
    transform: "translate(-201.933 -117.337)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119727",
    "data-name": "Path 119727",
    d: "M313.338,287.147A18.135,18.135,0,0,0,300.413,318l12.925-12.721,16.946,6.468a18.146,18.146,0,0,0-16.946-24.6Z",
    transform: "translate(-201.937 -117.341)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39113",
    "data-name": "Group 39113",
    transform: "translate(100.48 178.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119728",
    "data-name": "Path 119728",
    d: "M310.7,296.086h-7.719a.553.553,0,0,0-.551.551h0a.553.553,0,0,0,.551.551H310.7a.554.554,0,0,0,.551-.551h0A.553.553,0,0,0,310.7,296.086Z",
    transform: "translate(-302.425 -296.086)",
    fill: "#ffb284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119729",
    "data-name": "Path 119729",
    d: "M310.7,297.834h-7.719a.551.551,0,1,0,0,1.1H310.7a.551.551,0,0,0,0-1.1Z",
    transform: "translate(-302.425 -296.088)",
    fill: "#ffb284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119730",
    "data-name": "Path 119730",
    d: "M306.164,299.582h-3.187a.551.551,0,0,0,0,1.1h3.187a.551.551,0,0,0,0-1.1Z",
    transform: "translate(-302.425 -296.09)",
    fill: "#ffb284"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39114",
    "data-name": "Group 39114",
    transform: "translate(27.236 178.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119731",
    "data-name": "Path 119731",
    d: "M237.37,296.086H229.65a.553.553,0,0,0-.551.551h0a.553.553,0,0,0,.551.551h7.719a.553.553,0,0,0,.551-.551h0A.553.553,0,0,0,237.37,296.086Z",
    transform: "translate(-229.099 -296.086)",
    fill: "#ffb284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119732",
    "data-name": "Path 119732",
    d: "M237.37,297.834H229.65a.551.551,0,1,0,0,1.1h7.719a.551.551,0,1,0,0-1.1Z",
    transform: "translate(-229.099 -296.088)",
    fill: "#ffb284"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119733",
    "data-name": "Path 119733",
    d: "M232.838,299.582H229.65a.551.551,0,0,0,0,1.1h3.187a.551.551,0,0,0,0-1.1Z",
    transform: "translate(-229.099 -296.09)",
    fill: "#ffb284"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39115",
    "data-name": "Group 39115",
    transform: "translate(24.938 38.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25248",
    "data-name": "Rectangle 25248",
    width: 12.588,
    height: 78.415,
    transform: "translate(0 21.857)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25249",
    "data-name": "Rectangle 25249",
    width: 12.588,
    height: 100.272,
    transform: "translate(20.622)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25250",
    "data-name": "Rectangle 25250",
    width: 12.588,
    height: 59.452,
    transform: "translate(43.125 40.82)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25251",
    "data-name": "Rectangle 25251",
    width: 12.588,
    height: 86.885,
    transform: "translate(65.021 13.387)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25252",
    "data-name": "Rectangle 25252",
    width: 12.588,
    height: 47.815,
    transform: "translate(87.031 52.457)",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39116",
    "data-name": "Group 39116",
    transform: "translate(46.258 23.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119734",
    "data-name": "Path 119734",
    d: "M303.884,157.439H293.223a1.1,1.1,0,1,0,0,2.206h10.661a1.1,1.1,0,0,0,0-2.206Z",
    transform: "translate(-248.192 -140.361)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119735",
    "data-name": "Path 119735",
    d: "M295.651,161.456h-2.428a1.1,1.1,0,1,0,0,2.206h2.428a1.1,1.1,0,1,0,0-2.206Z",
    transform: "translate(-248.192 -140.366)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119736",
    "data-name": "Path 119736",
    d: "M259.907,140.342H249.246a1.1,1.1,0,0,0,0,2.206h10.661a1.1,1.1,0,0,0,0-2.206Z",
    transform: "translate(-248.143 -140.342)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119737",
    "data-name": "Path 119737",
    d: "M251.674,144.359h-2.428a1.106,1.106,0,0,0-1.1,1.1h0a1.106,1.106,0,0,0,1.1,1.1h2.428a1.106,1.106,0,0,0,1.1-1.1h0A1.106,1.106,0,0,0,251.674,144.359Z",
    transform: "translate(-248.143 -140.346)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119738",
    "data-name": "Path 119738",
    d: "M281.6,184.5h-10.66a1.1,1.1,0,0,0,0,2.206H281.6a1.1,1.1,0,0,0,0-2.206Z",
    transform: "translate(-248.167 -140.391)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119739",
    "data-name": "Path 119739",
    d: "M273.363,188.52h-2.427a1.106,1.106,0,0,0-1.1,1.1h0a1.106,1.106,0,0,0,1.1,1.1h2.427a1.106,1.106,0,0,0,1.1-1.1h0A1.106,1.106,0,0,0,273.363,188.52Z",
    transform: "translate(-248.167 -140.396)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119740",
    "data-name": "Path 119740",
    d: "M325.551,196.219h-10.66a1.1,1.1,0,0,0,0,2.206h10.66a1.1,1.1,0,1,0,0-2.206Z",
    transform: "translate(-248.216 -140.404)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119741",
    "data-name": "Path 119741",
    d: "M317.319,200.237h-2.428a1.1,1.1,0,0,0,0,2.206h2.428a1.1,1.1,0,0,0,0-2.206Z",
    transform: "translate(-248.216 -140.409)",
    fill: "#d0d0d0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39127",
    "data-name": "Group 39127",
    transform: "translate(0 11.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39120",
    "data-name": "Group 39120",
    transform: "translate(0 66.486)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25253",
    "data-name": "Rectangle 25253",
    width: 108.287,
    height: 60.962,
    fill: "#66c8ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25254",
    "data-name": "Rectangle 25254",
    width: 108.287,
    height: 60.962,
    transform: "translate(3.521)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10899",
    "data-name": "Ellipse 10899",
    cx: 19.579,
    cy: 19.579,
    r: 19.579,
    transform: "translate(5.447 29.104) rotate(-45)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39118",
    "data-name": "Group 39118",
    transform: "translate(65.063 18.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119742",
    "data-name": "Path 119742",
    d: "M159.055,213.279H126.62a2.143,2.143,0,0,0-2.137,2.138h0a2.143,2.143,0,0,0,2.137,2.138h32.436a2.144,2.144,0,0,0,2.138-2.138h0A2.144,2.144,0,0,0,159.055,213.279Z",
    transform: "translate(-124.483 -213.279)",
    fill: "#99daf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119743",
    "data-name": "Path 119743",
    d: "M159.055,222.09H126.62a2.142,2.142,0,0,0-2.137,2.137h0a2.143,2.143,0,0,0,2.137,2.138h32.436a2.144,2.144,0,0,0,2.138-2.138h0A2.143,2.143,0,0,0,159.055,222.09Z",
    transform: "translate(-124.483 -213.289)",
    fill: "#99daf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119744",
    "data-name": "Path 119744",
    d: "M159.055,230.9H126.62a2.137,2.137,0,0,0,0,4.274h32.436a2.137,2.137,0,1,0,0-4.274Z",
    transform: "translate(-124.483 -213.299)",
    fill: "#99daf3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_119745",
    "data-name": "Path 119745",
    d: "M74.575,223.924H92.5V206A17.927,17.927,0,0,0,74.575,223.924Z",
    transform: "translate(-59.365 -195.105)",
    fill: "#28536b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119746",
    "data-name": "Path 119746",
    d: "M110.428,224.522H74.575A17.928,17.928,0,0,0,92.5,242.449h0A17.928,17.928,0,0,0,110.428,224.522Z",
    transform: "translate(-59.365 -195.126)",
    fill: "#28536b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39119",
    "data-name": "Group 39119",
    transform: "translate(27.755 33.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119747",
    "data-name": "Path 119747",
    d: "M97.87,228.909H88.141a1.006,1.006,0,1,0,0,2.013H97.87a1.006,1.006,0,1,0,0-2.013Z",
    transform: "translate(-87.134 -228.909)",
    fill: "#7e98a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119748",
    "data-name": "Path 119748",
    d: "M90.356,232.576H88.141a1.009,1.009,0,0,0-1.007,1.006h0a1.01,1.01,0,0,0,1.007,1.007h2.216a1.01,1.01,0,0,0,1.007-1.007h0A1.009,1.009,0,0,0,90.356,232.576Z",
    transform: "translate(-87.134 -228.913)",
    fill: "#7e98a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39123",
    "data-name": "Group 39123",
    transform: "translate(0 138.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119749",
    "data-name": "Path 119749",
    d: "M59.348,267.052V329.4H167.634V267.052Z",
    transform: "translate(-59.348 -267.052)",
    fill: "#66c8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119750",
    "data-name": "Path 119750",
    d: "M62.873,267.052V329.4H171.159V267.052Z",
    transform: "translate(-59.352 -267.052)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10900",
    "data-name": "Ellipse 10900",
    cx: 19.579,
    cy: 19.579,
    r: 19.579,
    transform: "matrix(0.443, -0.896, 0.896, 0.443, 6.905, 38.118)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39121",
    "data-name": "Group 39121",
    transform: "translate(65.06 18.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119751",
    "data-name": "Path 119751",
    d: "M126.619,289.657h32.436a2.137,2.137,0,0,0,0-4.274H126.619a2.137,2.137,0,1,0,0,4.274Z",
    transform: "translate(-124.481 -285.383)",
    fill: "#99daf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119752",
    "data-name": "Path 119752",
    d: "M159.054,294.193H126.619a2.137,2.137,0,1,0,0,4.274h32.436a2.137,2.137,0,0,0,0-4.274Z",
    transform: "translate(-124.481 -285.393)",
    fill: "#99daf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119753",
    "data-name": "Path 119753",
    d: "M159.054,303H126.619a2.144,2.144,0,0,0-2.138,2.138h0a2.144,2.144,0,0,0,2.138,2.137h32.436a2.143,2.143,0,0,0,2.137-2.137h0A2.144,2.144,0,0,0,159.054,303Z",
    transform: "translate(-124.481 -285.403)",
    fill: "#99daf3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_119754",
    "data-name": "Path 119754",
    d: "M92.5,296.651l-17.925-.228c0,.075,0,.152,0,.228a17.927,17.927,0,0,0,27.544,15.129Z",
    transform: "translate(-59.365 -267.085)",
    fill: "#28536b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39122",
    "data-name": "Group 39122",
    transform: "translate(23.06 35.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25255",
    "data-name": "Rectangle 25255",
    width: 11.742,
    height: 2.013,
    rx: 1.006,
    fill: "#7e98a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119755",
    "data-name": "Path 119755",
    d: "M85.656,305.968H83.44a1.007,1.007,0,0,0,0,2.014h2.217a1.007,1.007,0,0,0,0-2.014Z",
    transform: "translate(-82.434 -302.306)",
    fill: "#7e98a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39126",
    "data-name": "Group 39126"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25256",
    "data-name": "Rectangle 25256",
    width: 108.288,
    height: 56.496,
    fill: "#66c8ec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25257",
    "data-name": "Rectangle 25257",
    width: 108.287,
    height: 56.496,
    transform: "translate(3.521)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10901",
    "data-name": "Ellipse 10901",
    cx: 19.579,
    cy: 19.579,
    r: 19.579,
    transform: "matrix(0.952, -0.305, 0.305, 0.952, 8.515, 16.408)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119756",
    "data-name": "Path 119756",
    d: "M92.5,139.7a17.927,17.927,0,0,0-8.6,33.654c2.872-5.319,8.6-15.729,8.6-15.729l8.488,15.791A17.927,17.927,0,0,0,92.5,139.7Z",
    transform: "translate(-59.365 -128.545)",
    fill: "#28536b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39124",
    "data-name": "Group 39124",
    transform: "translate(65.061 18.141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25258",
    "data-name": "Rectangle 25258",
    width: 36.71,
    height: 4.274,
    rx: 2.137,
    fill: "#99daf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119757",
    "data-name": "Path 119757",
    d: "M159.054,155.5H126.619a2.137,2.137,0,0,0,0,4.274h32.436a2.137,2.137,0,1,0,0-4.274Z",
    transform: "translate(-124.482 -146.703)",
    fill: "#99daf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119758",
    "data-name": "Path 119758",
    d: "M159.054,164.313H126.619a2.138,2.138,0,0,0,0,4.275h32.436a2.138,2.138,0,0,0,0-4.275Z",
    transform: "translate(-124.482 -146.713)",
    fill: "#99daf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39125",
    "data-name": "Group 39125",
    transform: "translate(23.061 20.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119759",
    "data-name": "Path 119759",
    d: "M93.169,149.072H83.441a1.006,1.006,0,1,0,0,2.013h9.728a1.006,1.006,0,1,0,0-2.013Z",
    transform: "translate(-82.434 -149.072)",
    fill: "#7e98a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119760",
    "data-name": "Path 119760",
    d: "M85.656,152.738H83.441a1.01,1.01,0,0,0-1.007,1.007h0a1.01,1.01,0,0,0,1.007,1.007h2.216a1.009,1.009,0,0,0,1.006-1.007h0A1.009,1.009,0,0,0,85.656,152.738Z",
    transform: "translate(-82.434 -149.076)",
    fill: "#7e98a6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_119761",
    "data-name": "Path 119761",
    d: "M92.5,221.981v4.46l-17.926-1.923v-.577l5.971-2.495Z",
    transform: "translate(-59.365 -117.268)",
    fill: "#28536b"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119762",
    "data-name": "Path 119762",
    d: "M389.359,87.016l5.536-2.474,1.1-5.962a.833.833,0,0,1,1.437-.408l4.063,4.5,6.011-.8a.833.833,0,0,1,.831,1.242l-3.025,5.255,2.615,5.471a.833.833,0,0,1-.924,1.175l-5.932-1.253-4.4,4.177a.833.833,0,0,1-1.4-.515l-.642-6.029L389.3,88.509A.833.833,0,0,1,389.359,87.016Z",
    transform: "translate(-0.434 -0.087)",
    fill: "#00a3e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119763",
    "data-name": "Path 119763",
    d: "M427.993,64.665l4.973.28,3.05-3.938a.685.685,0,0,1,1.2.245l1.27,4.817,4.689,1.684a.685.685,0,0,1,.139,1.22l-4.188,2.7-.153,4.979a.685.685,0,0,1-1.118.509L434,74.006,429.218,75.4a.685.685,0,0,1-.83-.9l1.8-4.644-2.8-4.117A.684.684,0,0,1,427.993,64.665Z",
    transform: "translate(-0.477 -0.068)",
    fill: "#ff7f32"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39129",
    "data-name": "Group 39129",
    transform: "translate(188.684 124.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119764",
    "data-name": "Path 119764",
    d: "M214.4,144.864a7.9,7.9,0,0,0,2.556-.754A5.856,5.856,0,0,0,219.1,142.5a3.537,3.537,0,0,0,.679-3.277,3.432,3.432,0,0,0-3.3-2.116,5.174,5.174,0,0,0-3.637,1.833c-1.006,1.123-2.609,3.136-1.646,4.706A2.712,2.712,0,0,0,213,144.8,4.8,4.8,0,0,0,214.4,144.864Z",
    transform: "translate(-188.919 -124.505)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119765",
    "data-name": "Path 119765",
    d: "M212.432,127.637a2.618,2.618,0,0,0-5.123-1.08C206.61,129.846,211.745,130.931,212.432,127.637Z",
    transform: "translate(-188.915 -124.491)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119766",
    "data-name": "Path 119766",
    d: "M204.335,139.307a3.045,3.045,0,0,0-.234-2.427,3.5,3.5,0,0,0-1.206-1.591,1.576,1.576,0,0,0-1.88.055,2.135,2.135,0,0,0-.521,1.027c-.3,1.086-.867,3.594.41,4.306C201.958,141.265,203.886,140.314,204.335,139.307Z",
    transform: "translate(-188.907 -124.503)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119767",
    "data-name": "Path 119767",
    d: "M206.984,153.252a2.881,2.881,0,0,0-.289-1.868,2.222,2.222,0,0,0-2.032-.742A4.119,4.119,0,0,0,201.869,152a3.534,3.534,0,0,0,1.393,5.444C205.868,158.613,206.853,155.087,206.984,153.252Z",
    transform: "translate(-188.908 -124.521)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119768",
    "data-name": "Path 119768",
    d: "M195.009,144.549a3.97,3.97,0,0,0-2.049-1.68,10.527,10.527,0,0,0-2.632-.574,1.422,1.422,0,0,0-1.2.222,1.224,1.224,0,0,0-.123,1.245,8.688,8.688,0,0,0,3.544,3.986C194.555,148.737,195.922,146.2,195.009,144.549Z",
    transform: "translate(-188.895 -124.511)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119769",
    "data-name": "Path 119769",
    d: "M190.872,134.6a1.789,1.789,0,0,0,1.777-1.134,1.767,1.767,0,0,0-2.716-1.985,1.733,1.733,0,0,0,.939,3.118Z",
    transform: "translate(-188.895 -124.499)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119770",
    "data-name": "Path 119770",
    d: "M193.068,156.343a1.128,1.128,0,0,0-.479-.9,2.75,2.75,0,0,0-.965-.422,2.834,2.834,0,0,0-1.44-.1c-1.511.394-.829,2.08.276,2.514C191.267,157.755,193.03,157.409,193.068,156.343Z",
    transform: "translate(-188.895 -124.525)",
    fill: "#ff7f32"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119771",
    "data-name": "Path 119771",
    d: "M177.756,317.653a1.6,1.6,0,0,0,.887-2.36,7.246,7.246,0,0,0-12.2-.384c-.809,1.178-1.255,2.565-1.956,3.81a4.78,4.78,0,0,1-3.2,2.62c-1.96.287-3.679-1.328-5.63-1.668a4.467,4.467,0,0,0-5.19,3.69,1.6,1.6,0,0,0,1.55,1.861l.186,0a1.6,1.6,0,0,0,1.47-.914,2,2,0,0,1,.731-.807,2.134,2.134,0,0,1,1.821-.02c.586.227,1.106.594,1.669.872a7.016,7.016,0,0,0,5.689.078A10.11,10.11,0,0,0,168,320.7a32.857,32.857,0,0,1,2.079-3.111,4.139,4.139,0,0,1,3.227-1.622,2.506,2.506,0,0,1,1.926,1.184,1.564,1.564,0,0,0,1.8.722C177.272,317.8,177.516,317.728,177.756,317.653Z",
    transform: "translate(-0.168 -0.348)",
    fill: "#e4e4e4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_39130",
    "data-name": "Group 39130",
    transform: "translate(382.318 303.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119772",
    "data-name": "Path 119772",
    d: "M382.79,315.919c-.6,6.528,5.008,12.494,11.233,13.584,6.448,1.128,12.193-3.074,14.412-9.014,4.375-11.719-8.447-20.962-15.4-13.871-6.492,6.62-4.439,16.454,2.568,16.457,2.643,0,6.9-2.215,5.21-5.42a1.069,1.069,0,0,0-1.834,0c-.85,1.448-.782,1.5-1.185,1.824a3.6,3.6,0,0,1-2.3.662c-7.135-.122-2.391-16.448,6.02-12.493,4.619,2.172,5.98,7.424,4.378,12.008-1.543,4.414-5.683,7.834-10.471,7.527-5.721-.367-10.518-5.626-10.889-11.262a.874.874,0,0,0-1.748,0Z",
    transform: "translate(-382.745 -304.143)",
    fill: "#e4e4e4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsPageArtWork);
export default __webpack_public_path__ + "static/media/InsightsPageArtWork.858e500f09904cebafc5a1585c8a4c9c.svg";
export { ForwardRef as ReactComponent };